import React from 'react'

import APIRefBlockSwagger from './APIRefBlockSwagger'
import getCodePieces from '../../../../static/jscript/fortmatHtml'
import { CopyButton } from '../CopyButton/CopyButton'
import { copyToClipboard } from '../../../utils'
import { CopyPasteIcon, SuccessCheckIcon } from '../../icons'

export default function Responses({
  samples,
  parameters,
  opAnchor,
  cleanedResponse,
  preamble,
}) {
  const [isCopied, setIsCopied] = React.useState(false)
  const handleCopyClipboard = (code) => {
    copyToClipboard(code)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 3000)
  }

  if (!samples || samples.length === 0) {
    return null
  }
  let reqIfNoParams = null
  if (!parameters || parameters.length === 0) {
    reqIfNoParams = samples.map((sample, index) => {
      if (sample.request) {
        return (
          <div key={index}>
            <div className="dax-title-section">
              <h4 className="dax-sample-heading">Sample Request</h4>
              <div className="dax-copy-button">
                <CopyButton
                  onClick={() => handleCopyClipboard(sample.response)}
                >
                  {isCopied ? <SuccessCheckIcon /> : <CopyPasteIcon />}
                </CopyButton>
              </div>
            </div>

            <pre className="language-json dx-pre-hljs apiReference-response">
              <code>{getCodePieces(sample.response)}</code>
            </pre>
          </div>
        )
      }
    })
  }
  return (
    <div className="dax-reference-set example-block dax-sample-response">
      <div className="dax-reference">
        {/* API ref block swagger here
                {> "layouts/apis/swagger/api-refblock-swagger.en-XC" /}
                */}
        <APIRefBlockSwagger
          opName={opAnchor}
          transaction="response"
          transactionTitle="Response"
          isArray="responseArray"
          transactionId="response"
          block="response"
          parameters={cleanedResponse}
          preamble={preamble}
        />
      </div>
      <div className="dax-sample dax-sample-codeblock">
        {reqIfNoParams}
        {samples.map((sample, index) => {
          if (sample.response) {
            return (
              <div key={index}>
                <div className="dax-title-section">
                  <h4 className="dax-sample-heading">Sample Response</h4>
                  <div className="dax-copy-button">
                    <CopyButton
                      onClick={() => handleCopyClipboard(sample.response)}
                    >
                      {isCopied ? <SuccessCheckIcon /> : <CopyPasteIcon />}
                    </CopyButton>
                  </div>
                </div>

                <pre className="language-json dx-pre-hljs apiReference-response">
                  <code>{getCodePieces(sample.response)}</code>
                </pre>
              </div>
            )
          }
        })}
      </div>
    </div>
  )
}
